// These constants implement the specification in:
// https://docs.google.com/spreadsheets/d/124v5579b27F4WkkPLoRxJ2UibK4IwRS0krmHZaDtpW8/edit#gid=0
import { INTENT_GET_ROADMAP } from '../goal/constants'

const JOIN_PATH = 'join'
const JOIN_START_PATH = 'join/start'
const JOIN_PATH_REFER = 'join-refer'
const JOIN_PATH_KICKSTART = 'join-kickstart'
const JOIN_PATH_MEDI_CAL_WAIVER = 'join-medi-cal-waiver'
const JOIN_PATH_MEDI_CAL_SECONDARY = 'join-medi-cal-secondary'
const JOIN_PATH_REGIONAL_CENTER = 'join-apply-regional-center'
const JOIN_PATH_IHSS = 'join-obtain-ihss'
const JOIN_PATH_IEP = 'join-annual-iep'
const INVITE_PATH_SKIP_CALL = 'invite-skip-call'

const PROVIDER_PATH_REFER = 'provider-refer'

const VERIFY_EMAIL_QUOTES = [
  'We joined Undivided after years of struggling on our own.',
  'It was like a light shone on us, and we could see the path ahead.”'
].join(' ')

const EMAIL_CONFIRMATION_INSTRUCTIONS = [
  'Enter the 6-digit code sent to your email. If you don’t see it, check your spam folder.',
  'Verifying your email will help keep your account safe.'
].join(' ')

const ZIP_CODE_NOT_FOUND_MESSAGE =
  'Sorry, the zip code you entered wasn’t found. Please check and try entering it again.'

const SCHEDULE_CALL_CLIENT_QUOTES = 'The first meeting felt like a breath of fresh air.”'

const SCHEDULE_CALL_CLIENT_NAME = 'Tselote T.'

const THANK_YOU_QUOTES = [
  'Thank you so much for\nyour support!',
  'The value\nof [Undivided] is beyond\nwords-I don’t feel so\nalone in all of this',
  'now\nthat I have a team of\npeople to bounce ideas\noff of (and vent to!)'
].join(' ')

const SCHEDULED_CALL_QUOTES = [
  'Working with my\nNavigator has entirely changed my perspective.',
  'I\n went from feeling like a\nvictim to feeling like a\nchampion.'
].join(' ')

const JOIN_GET_STARTED_CONTENT = [
  '“I’ve repeatedly found that patients whose families work with Undivided',
  'don’t face the same challenges accessing or affording care for their children.”'
].join(' ')

// Each string in the array indicates a separate paragraph.
const JOIN_IEP_COPY = [
  [
    'Set up your account with Undivided and begin your free kickstart',
    'to get IEP help and access to education advocacy.'
  ].join(' '),

  [
    'During your kickstart, you’ll be matched with a Navigator to help you identify your goals,',
    'and we will add a step-by-step guide to preparing for an IEP meeting to your account',
    'so that you can get started right away.'
  ].join(' ')
]

const HELP_LABEL = 'Contact support'
const HELP_CALL_LINK = 'mailto:support@undivided.io?subject=I%20need%20help%20creating%20an%20account'

const JOIN_SITES_ALL = [
  {
    path: JOIN_PATH,
    funnelId: 1,
    gated: false,
    clearUser: false
  },

  {
    path: JOIN_PATH_KICKSTART,
    funnelId: 2,
    gated: true,
    clearUser: true
  },

  {
    path: JOIN_PATH_MEDI_CAL_WAIVER,
    funnelId: 3,
    gated: false,
    clearUser: true
  },

  {
    path: JOIN_PATH_MEDI_CAL_SECONDARY,
    funnelId: 4,
    gated: false,
    clearUser: true
  },

  {
    path: JOIN_PATH_REGIONAL_CENTER,
    funnelId: 5,
    gated: false,
    clearUser: true
  },

  {
    path: JOIN_PATH_IHSS,
    funnelId: 6,
    gated: false,
    clearUser: true
  },

  {
    path: JOIN_PATH_IEP,
    copy: JOIN_IEP_COPY,
    funnelId: 7,
    gated: false,
    clearUser: true
  },

  {
    path: JOIN_PATH_REFER,
    funnelId: 8,
    gated: false,
    clearUser: true
  },

  {
    path: INVITE_PATH_SKIP_CALL,
    funnelId: 9,
    gated: false,
    clearUser: true
  }
]

const PROVIDER_SITES_ALL = [
  {
    path: PROVIDER_PATH_REFER,
    funnelId: 10,
    gated: false
  }
]

const ONBOARDING_FUNNELS = {
  1: { kickstart: false, zipCode: false },
  2: { kickstart: true, zipCode: true },
  3: { kickstart: true, zipCode: true },
  4: { kickstart: true, zipCode: true },
  5: { kickstart: true, zipCode: true },
  6: { kickstart: true, zipCode: true },
  7: { kickstart: true, zipCode: true },
  9: { kickstart: false, zipCode: false } // This is the invite-but-skip-scheduling funnel.
}

const sitePath = joinSite => joinSite.path

const JOIN_PATHS_GATED = JOIN_SITES_ALL.filter(joinSite => joinSite.gated).map(sitePath)
const JOIN_PATHS_PUBLIC = JOIN_SITES_ALL.filter(joinSite => !joinSite.gated)

const PROVIDER_PATHS_GATED = PROVIDER_SITES_ALL.filter(providerSite => providerSite.gated).map(sitePath)
const PROVIDER_PATHS_PUBLIC = PROVIDER_SITES_ALL.filter(providerSite => !providerSite.gated).map(sitePath)

const JOIN_SITE_MAP = Object.fromEntries(JOIN_SITES_ALL.map(joinSite => [`/${joinSite.path}`, joinSite]))
const PROVIDER_SITE_MAP = Object.fromEntries(
  PROVIDER_SITES_ALL.map(providerSite => [`/${providerSite.path}`, providerSite])
)

const ONBOARDING_LANDING = 'onboarding'
const ZIP_CODE_REQUIRED_PATH = 'zipcode-required' // Where a parent who still owes us a zip code is sent (see gates.js).
const ONBOARDING_CONCLUSION = 'home'

const CHECKPOINT_WELCOME = 'welcome'
const CHECKPOINT_TOPICS = 'topics'
const CHECKPOINT_CHILD = 'child'
const CHECKPOINT_LEAD_SOURCE = 'lead-source'
const CHECKPOINT_BENEFITS = 'public-benefits'
const CHECKPOINT_KICKSTART = 'kickstart'
const CHECKPOINT_QUALIFICATION = 'qualification'
const CHECKPOINT_QUALIFIED = 'qualified'
const CHECKPOINT_EMPTY = ''
const NO_CHECKPOINT = 'noCheckPoint'
const CHECKPOINT_TRIAL_UPSELL = 'trial-upsell'
const CHECKPOINT_CHILD_INFO = 'childInfo'
const CHECKPOINT_VERIFY_EMAIL = 'verify-email'
const CHECKPOINT_SCHEDULE_CONFIRMATION = 'scheduleConfirmation'
const CHECKPOINT_PAYMENT_CC = 'payment-cc'

const LOOKUP = 'lookup'
const IN_PROGRESS = 'in progress'
const FORM_FILLIN = 'form fill-in'
const CONFIRMED = 'confirmed'
const EXPIRED = 'expired'
const PROBLEM = 'problem'

const QUALIFIED = 'qualified'
const NOT_QUALIFIED = 'notQualified'
const BYPASS = 'bypass'

const DESTINATION_HOME = 'home'
const DESTINATION_SCHEDULE = 'schedule'
const DESTINATION_CONFIRMATION = 'confirmCode'

const CHILD_TYPE_OPTIONS = [
  { label: 'Parent or caregiver of a child 18 and younger', value: 'minor' },
  { label: 'Parent or caregiver of an adult child 19+', value: 'adult-child' },
  { label: 'Adult living with one or more disability', value: 'adult-living-with' },
  { label: 'Provider or work with families in need', value: 'provider' }
]

const OPTION_NO_CHILD_TYPE = '__no-child-type__'
const PAYMENT_MODULE = 'payment'
const PAYMENT_BENEFITS_MODULE = 'paymentBenefits'
const TRIAL_PAYMENT_MODULE = 'trialPayment'
const SCHEDULE_KICKSTART_MODULE = 'scheduleKickstart'
const COPILOT_MODULE = 'copilot'
const SCHEDULE_KICKSTART_CALL = 'scheduleKickstartCall'
const RESOURCES_INTERSTITIAL = 'resourcesInterstitial'
const ABOUT_NAVIGATORS_MODULE = 'aboutNavigators'
const ABOUT_UNDIVIDED_MODULE = 'aboutUndivided'
const PRODUCT_TABLE = 'productTable'
const BENEFITS = 'benefits'
const IEP_TRACK_IEP_MODULE = 'iep'
const PLAN_504_TRACK_504_MODULE = '504'
const PRIMARY_AUDIT_MODULE = 'primaryAudit'
const SECONDARY_AUDIT_MODULE = 'secondaryAudit'
const IEP_TRACK_IN_PROCESS_MODULE = 'iepProcess'
const PLAN_504_TRACK_IN_PROCESS_MODULE = '504Process'
const ZIP_CODE_MODULE = 'zipCode'

const ROADMAP_WALKTHROUGH_LINK = `/roadmaps?intent=${INTENT_GET_ROADMAP}`

const FUNNEL_INTENT = 'Intent'
const FUNNEL_RESOURCES = 'Resources'
const FUNNEL_CREATE_ROADMAP = 'Create Roadmap'
const FUNNEL_ANDY = 'Andy AI'
const FUNNEL_PAYMENT_COLLECT = 'Payment Collect'

// Code for kickstart direct flow.
const KICKSTART_DIRECT_CODE = 'KSdirect-25'

// Pre-sign up tracks that folows new onboarding flow

const IEP_TRACK_FLOW = 'iepTrack'
const NAV_TRACK_FLOW = 'navTrack'
const GENERAL_TRACK_FLOW = 'generalTrack'
const PUBLIC_BENEFITS_TRACK_FLOW = 'publicBenefitsTrack'
const OVER_22_TRACK_FLOW = 'over22Track'
const RESOURCE_TRACK_FLOW = 'resourceTrack'
const NAVIGATOR_FLOW = 'Navigator'
const DIRECT_TO_KICKSTART_FLOW = 'directToKickstart'
const PROVIDER_TRACK_FLOW = 'providerTrack'
const PROVIDER_REFERRAL_FLOW = 'providerReferral'

const KNOWN_FLOWS = [
  IEP_TRACK_FLOW,
  NAV_TRACK_FLOW,
  GENERAL_TRACK_FLOW,
  PUBLIC_BENEFITS_TRACK_FLOW,
  OVER_22_TRACK_FLOW,
  RESOURCE_TRACK_FLOW,
  NAVIGATOR_FLOW,
  DIRECT_TO_KICKSTART_FLOW,
  PROVIDER_TRACK_FLOW,
  PROVIDER_REFERRAL_FLOW
]

// [UND-4850] As for the marketing sites we now about to have both direct to paid user payment and trial payment in the app, if the module is trialPayment then we show perious trial payment page that puts the user in trial and if the module is payment then we show direct to paid user payment page.

const TRIAL_PAYMENT_TEST = 'trialPaymentTest'

// [UND-4850] Add trial upsell onboarding flows to the app.
// this is used for in app upgrade modal , since we don't have specific identifier for which we have to show trial in in-app upgrade modal.
// we use the flows for which we show trial payment page to determine if we have to show trial in in-app upgrade modal.
const TRIAL_UPSELL_ONBOARDING_FLOWS = [TRIAL_PAYMENT_TEST]

export {
  JOIN_SITES_ALL,
  PROVIDER_SITES_ALL,
  JOIN_PATH,
  JOIN_START_PATH,
  JOIN_PATH_KICKSTART,
  JOIN_PATH_MEDI_CAL_WAIVER,
  JOIN_PATHS_GATED,
  PROVIDER_PATHS_GATED,
  JOIN_PATH_MEDI_CAL_SECONDARY,
  JOIN_PATH_REGIONAL_CENTER,
  JOIN_PATH_IHSS,
  JOIN_PATH_IEP,
  JOIN_PATHS_PUBLIC,
  PROVIDER_PATHS_PUBLIC,
  JOIN_GET_STARTED_CONTENT,
  JOIN_SITE_MAP,
  PROVIDER_SITE_MAP,
  ONBOARDING_FUNNELS,
  ONBOARDING_LANDING,
  ZIP_CODE_REQUIRED_PATH,
  ONBOARDING_CONCLUSION,
  CHECKPOINT_WELCOME,
  CHECKPOINT_TOPICS,
  CHECKPOINT_CHILD,
  CHECKPOINT_LEAD_SOURCE,
  CHECKPOINT_BENEFITS,
  CHECKPOINT_KICKSTART,
  CHECKPOINT_QUALIFICATION,
  CHECKPOINT_QUALIFIED,
  CHECKPOINT_SCHEDULE_CONFIRMATION,
  CHECKPOINT_PAYMENT_CC,
  NO_CHECKPOINT,
  THANK_YOU_QUOTES,
  SCHEDULED_CALL_QUOTES,
  EMAIL_CONFIRMATION_INSTRUCTIONS,
  ZIP_CODE_NOT_FOUND_MESSAGE,
  SCHEDULE_CALL_CLIENT_QUOTES,
  SCHEDULE_CALL_CLIENT_NAME,
  HELP_LABEL,
  HELP_CALL_LINK,
  CHECKPOINT_EMPTY,
  CHILD_TYPE_OPTIONS,
  OPTION_NO_CHILD_TYPE,
  QUALIFIED,
  NOT_QUALIFIED,
  BYPASS,
  DESTINATION_HOME,
  DESTINATION_SCHEDULE,
  DESTINATION_CONFIRMATION,
  CHECKPOINT_TRIAL_UPSELL,
  CHECKPOINT_VERIFY_EMAIL,
  VERIFY_EMAIL_QUOTES,
  ROADMAP_WALKTHROUGH_LINK,
  FUNNEL_INTENT,
  FUNNEL_CREATE_ROADMAP,
  FUNNEL_RESOURCES,
  FUNNEL_PAYMENT_COLLECT,
  FUNNEL_ANDY,
  SCHEDULE_KICKSTART_MODULE,
  SCHEDULE_KICKSTART_CALL,
  RESOURCES_INTERSTITIAL,
  KICKSTART_DIRECT_CODE,
  RESOURCE_TRACK_FLOW,
  LOOKUP,
  IN_PROGRESS,
  FORM_FILLIN,
  CONFIRMED,
  EXPIRED,
  PROBLEM,
  OVER_22_TRACK_FLOW,
  IEP_TRACK_FLOW,
  NAV_TRACK_FLOW,
  GENERAL_TRACK_FLOW,
  PUBLIC_BENEFITS_TRACK_FLOW,
  TRIAL_UPSELL_ONBOARDING_FLOWS,
  NAVIGATOR_FLOW,
  DIRECT_TO_KICKSTART_FLOW,
  PROVIDER_TRACK_FLOW,
  PROVIDER_REFERRAL_FLOW,
  KNOWN_FLOWS,
  ABOUT_NAVIGATORS_MODULE,
  ABOUT_UNDIVIDED_MODULE,
  BENEFITS,
  CHECKPOINT_CHILD_INFO,
  COPILOT_MODULE,
  IEP_TRACK_IEP_MODULE,
  IEP_TRACK_IN_PROCESS_MODULE,
  PAYMENT_MODULE,
  PAYMENT_BENEFITS_MODULE,
  PLAN_504_TRACK_504_MODULE,
  PLAN_504_TRACK_IN_PROCESS_MODULE,
  PRIMARY_AUDIT_MODULE,
  PRODUCT_TABLE,
  SECONDARY_AUDIT_MODULE,
  TRIAL_PAYMENT_MODULE,
  ZIP_CODE_MODULE
}
